const baseColors = {
  primary: {
    stvPurple: '#810EA9',
    white: '#fff',
    midGrey1: '#656565',
    black: '#101820',
  },
  secondary: {
    lightGrey1: '#f6f6f6',
    lightGrey2: '#ddd',
    midGrey2: '#767676',
    darkGrey: '#454545',
  },
  utility: {
    heroPurple: '#C448F0',
    lightBlue: '#3db1ff',
    yellow: '#ffc666',
    green: '#68b000',
    red: '#c12a26',
  },
}

const darkBaseColors = {
  primary: {
    purple1: '#810EA9',
    white1: '#F6F6F6',
    grey1: '#151515',
  },
  secondary: {
    purple2: '#9916C7',
    grey2: '#212121',
    white2: '#C4C4C4',
  },
  tertiary: {
    purple3: '#C448F0',
    grey3: '#313131',
    white3: '#9E9E9E',
  },
  quaternary: {
    grey4: '#515151',
  },
}

export const colors = {
  // background and divider colors
  baseBg: darkBaseColors.primary.grey1,
  elevatedBg: darkBaseColors.secondary.grey2,
  ctvBg: darkBaseColors.tertiary.grey3,
  textInput: darkBaseColors.quaternary.grey4,

  // text colors
  primaryText: darkBaseColors.primary.white1,
  secondaryText: darkBaseColors.secondary.white2,
  tertiaryText: darkBaseColors.tertiary.white3,

  // purples
  darkPurple: darkBaseColors.primary.purple1, // not used?
  IconButtonPurple: darkBaseColors.secondary.purple2,
  textHoverPurple: darkBaseColors.tertiary.purple3,
  categoriesPurple: '#dd96ff',
  categoriesDarkPurple: '#372349',
  stvPurple: baseColors.primary.stvPurple,

  // misc legacy
  midText: baseColors.primary.midGrey1,
  darkText: baseColors.secondary.darkGrey,
  black: baseColors.primary.black,
  lightGrey2: baseColors.secondary.lightGrey2,
  lightGrey3: '#e5e5e5',
  midGrey2: baseColors.secondary.midGrey2,
  darkGrey: baseColors.secondary.darkGrey,
  white: baseColors.primary.white,
  cardBorder: 'rgba(0, 0, 0, 0.1875)',
  lightOverlay: 'rgba(246, 246, 246, 0.9)',
  red: baseColors.utility.red,
  green: baseColors.utility.green,
  darkRed: '#8f070a',
  liveRed: '#C92D45',
  hoverRed: '#E16A67',
  cardDarkBg: 'rgba(0, 0, 0, 0.5)',
  sponsorshipBg: '#201D22',
  keyLine: baseColors.secondary.lightGrey2,
  overlayBg: darkBaseColors.primary.grey1,
  twitter: '#66c9e8',
  facebook: '#3b5998',
  email: baseColors.utility.yellow,
}

export const grids = {
  narrow: {
    margin: 8, // space around grid
    gutter: 8, // space between columns
    breakpoint: 320,
  },
  narrowMedium: {
    margin: 12, // space around grid
    gutter: 24, // space between columns
    breakpoint: 320,
  },
  medium: {
    margin: 16,
    gutter: 16,
    breakpoint: 768,
  },
  wide: {
    margin: 32,
    gutter: 20,
    breakpoint: 1024,
  },
  superWide: {
    margin: 0,
    gutter: 0,
    breakpoint: 1920,
  },
}
